module.exports = __webpack_public_path__ + "static/media/tutorial1.e6e81aac.jpg";